import React from 'react';

function Footer() {
	return <footer className="footer-text">Created by: Raksha Aasish</footer>;
}

export default Footer;
